import { Timestamp } from "firebase/firestore";
import { Branch } from "../interfaces/entities/branch";

export const defaultBranch = (userId: string): Branch => ({
    id: "",
    companyId: "",
    name: "",
    address: "",
    phone: "",
    image: "",
    urlKey: "",

    createdAt: Timestamp.fromDate(new Date()),
    updatedAt: Timestamp.fromDate(new Date()),

    ownerId: userId
})
